// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"f14d1b0a","977":"4bfe979d"}[chunkId] + ".chunk.js";
};